mutation PaymentCreate($input: PaymentCreateInput!) {
  paymentCreate(input: $input) {
    payment {
      id
      payCycleId
      _rowTimestamp
      _isDeletable
      _isUpdatable
      _statusTypeId
      _isAccountingEntryStampedComplete
      _isTransactionPayment
      _payCycleDescription
      payCycle {
        isDraft
      }
      statusType {
        approvalState
        statusType
        _transactionIconStatus
      }
      company {
        id
        name
      }
      currency {
        id
        isoCode
        name
      }
      businessUnit {
        id
        name
      }
      paymentAccount {
        name
        bankAccountNumber
      }
      transactionType {
        id
        transactionType
      }
      vendorId
      vendorReference
      memo
      paymentReference
      paidDate
      _baseCurrencyAmount
      _spotCurrencyAmount
      paidAmount
      _invoiceTotal
      rowSecurityId
      invoicePayments {
        nodes {
          id
        }
      }
    }
  }
}
